import { Footer } from "antd/es/layout/layout";


const PageFooter = () => {
    return (
        <Footer style={{ textAlign: 'center', backgroundColor: '#FFFFFF' }}>trackr ©2023 Ron Varshavsky </Footer>
    )
}

export default PageFooter;